
import PlTableColumn from "./table_col"
export default PlTableColumn



// WEBPACK FOOTER //
// ./src/ni-ui/table/col/index.js